import React from 'react'

export default class IconsMainNavHelp extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <g clipPath='url(#clip0_44_6103)'>
                    <path
                        d='M7.99998 14.6667C11.6819 14.6667 14.6666 11.6819 14.6666 8.00004C14.6666 4.31814 11.6819 1.33337 7.99998 1.33337C4.31808 1.33337 1.33331 4.31814 1.33331 8.00004C1.33331 11.6819 4.31808 14.6667 7.99998 14.6667Z'
                        stroke='#646464'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M3.28668 3.28662L6.11335 6.11329'
                        stroke='#646464'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M9.88666 6.11329L12.7133 3.28662'
                        stroke='#646464'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M9.88666 9.88672L12.7133 12.7134'
                        stroke='#646464'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M6.11335 9.88672L3.28668 12.7134'
                        stroke='#646464'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M7.99998 10.6667C9.47274 10.6667 10.6666 9.4728 10.6666 8.00004C10.6666 6.52728 9.47274 5.33337 7.99998 5.33337C6.52722 5.33337 5.33331 6.52728 5.33331 8.00004C5.33331 9.4728 6.52722 10.6667 7.99998 10.6667Z'
                        stroke='#646464'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
                <defs>
                    <clipPath id='clip0_44_6103'>
                        <rect width='16' height='16' fill='white' />
                    </clipPath>
                </defs>
            </svg>
        )
    }
}
